module.exports = __webpack_public_path__ + "img/c-thermometer-img6-2.4c7d3d08.png";